import { cn } from '@/lib/utils';

interface CoreLogoProps {
  className?: string;
  markClassName?: string;
  showWordmark?: boolean;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'dark' | 'light';
}

const sizeClasses = {
  sm: { wrap: 'gap-[10px]', mark: 'size-7', text: 'text-[20px]' },
  md: { wrap: 'gap-[10px]', mark: 'size-9', text: 'text-2xl' },
  lg: { wrap: 'gap-3', mark: 'size-12', text: 'text-3xl' },
};

export function CoreLogo({
  className,
  markClassName,
  showWordmark = true,
  size = 'md',
  variant = 'dark',
}: CoreLogoProps) {
  const classes = sizeClasses[size];
  const isLight = variant === 'light';
  const stroke = isLight ? '#FFFFFF' : 'currentColor';
  const accentStroke = isLight ? '#FFFFFF' : 'currentColor';

  return (
    <div
      className={cn(
        'inline-flex items-center',
        classes.wrap,
        isLight ? 'text-white' : 'text-ink',
        className,
      )}
    >
      <svg
        viewBox="0 0 32 32"
        aria-hidden="true"
        fill="none"
        className={cn(classes.mark, 'shrink-0', markClassName)}
      >
        {/* outer rounded square (subtle) */}
        <rect
          x="0.75"
          y="0.75"
          width="30.5"
          height="30.5"
          rx="7.5"
          fill="none"
          stroke={stroke}
          strokeOpacity="0.18"
          strokeWidth="1"
        />
        {/* open C arc (Core) */}
        <path
          d="M21 11 A7 7 0 1 0 21 21"
          stroke={stroke}
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        {/* sine-curve undertone */}
        <path
          d="M11 16 C 13 13.5, 15 13.5, 16 16 S 19 18.5, 21 16"
          stroke={accentStroke}
          strokeOpacity="0.35"
          strokeWidth="1.25"
          strokeLinecap="round"
          fill="none"
        />
      </svg>

      {/* ⚠ THE PRODUCT NAME NOW WEARS THE COMPANY'S FACE. This was set in
          Fraunces — a serif agileandco.com does not use anywhere, so the
          product's own logotype was the one place Core looked least like
          Agile & Co. `--font-display` is the agency's actual brand face
          (parkside, via Typekit, verified loading on prod, dev and
          localhost). Core is an extension of Agile & Co; its wordmark should
          say so. */}
      {showWordmark && (
        <span
          className={cn(
            'font-display font-medium leading-none tracking-[-0.01em]',
            classes.text,
          )}
        >
          Core
        </span>
      )}
    </div>
  );
}
